import Calendar from '@engineering/icons/calendar';
import { ButtonWrapper, StyledButton } from './DatePickerButton.styles';
import { useFormattedDate } from './useFormattedDate';

type DatePickerButtonProps = {
  title: string;
  from?: Date;
  to?: Date;
  size?: 'small';
  onClick?: () => void;
};

const DatePickerButton = ({
  title,
  from,
  to,
  size,
  onClick,
}: DatePickerButtonProps) => {
  const fromDate = useFormattedDate(from);
  const toDate = useFormattedDate(to);

  return (
    <ButtonWrapper>
      <StyledButton
        type="button"
        id="datepicker"
        aria-haspopup="true"
        title={title}
        size={size}
        onClick={onClick}
      >
        {fromDate && toDate && (
          <span id="datepickerValue">{`${fromDate} - ${toDate}`}</span>
        )}
      </StyledButton>
      <Calendar id="datepicker-cal-icon" />
    </ButtonWrapper>
  );
};

export { DatePickerButton };
